import { useTranslation } from "react-i18next";

import {
  HookFormInput,
  HookFormBaseDropdown,
} from "@/components_v2/FormFields/ReactHookForm/fields";
import BaseInput from "@/components_v2/FormFields/Input/BaseInput";
import FormFieldWrapper from "@/components_v2/Wrapper/FormFieldWrapper";
import { OrganizationDetailsStepProps } from "../../types";

import "../../styles.css";

const OrganizationDetailsStep = ({
  form,
  countryOptions,
  organizationName,
}: OrganizationDetailsStepProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-400">
      <div className="flex flex-col gap-200">
        <h2 className="register__title header-m-medium">
          {t("auth.labels.organizationTitle")}
        </h2>
        <p className="register__description body-m-regular">
          {t("auth.labels.organizationDescription")}
        </p>
      </div>

      <div className="form-input-container text-start">
        <FormFieldWrapper label={t("auth.labels.organizationName")} required>
          <BaseInput
            disabled
            value={organizationName}
            placeholder={t("auth.placeholders.university")}
            onChange={() => {}}
          />
        </FormFieldWrapper>

        <FormFieldWrapper label={t("auth.labels.country")} required>
          <HookFormBaseDropdown
            name="organization.country"
            placeholder={t("auth.placeholders.selectCountry")}
            options={countryOptions}
            control={form.control}
          />
        </FormFieldWrapper>

        <FormFieldWrapper label={t("auth.labels.organizationAddress")} required>
          <HookFormInput
            name="organization.address"
            placeholder={t("auth.placeholders.enterAddress")}
            control={form.control}
          />
        </FormFieldWrapper>

        <FormFieldWrapper label={t("auth.labels.contactNumber")}>
          <HookFormInput
            name="organization.phoneNumber"
            placeholder={t("auth.placeholders.enterContactNumber")}
            control={form.control}
          />
        </FormFieldWrapper>

        <FormFieldWrapper label={t("auth.labels.contactEmail")} required>
          <HookFormInput
            name="organization.email"
            placeholder={t("auth.placeholders.enterContactEmail")}
            control={form.control}
          />
        </FormFieldWrapper>
      </div>
    </div>
  );
};

export default OrganizationDetailsStep;
